<script setup lang="ts">
import { ref } from "vue";
import {useCachedCmsElementsFromCategory} from "~/composables/useCachedCmsElementsFromCategory";
const { loadCmsElementsFromCategory } = useCachedCmsElementsFromCategory();
const route = useRoute();

const layoutId = "018d6f4cc24f725dbcda6742a646a11a"

let cmsElementsFromCategory = ref();

cmsElementsFromCategory.value = await loadCmsElementsFromCategory(layoutId);

</script>
<template>
  <CmsPage v-if="cmsElementsFromCategory?.cmsPage" :content="cmsElementsFromCategory.cmsPage" />
</template>